import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

interface LoadingCardProps {
  height?: string;
}

export const LoadingCard: React.FC<LoadingCardProps> = ({ height = '40px' }) => (
  <Flex justify="center" py={height}>
    <Spinner size="md" color="brand.500" />
  </Flex>
);
